const dic = JSON.parse(localStorage.dic);

const VIP_LEVEL = dic['VIP_LEVEL'];

let ascVipLevelList = [];
for (let key in VIP_LEVEL) {
  ascVipLevelList.push({
    value: key,
    label: VIP_LEVEL[key]
  });
}
ascVipLevelList.sort((a, b) => a.value - b.value);

export default {
  data() {
    return {
      VIP_LEVEL, // 原始的vipLevel字典
      ascVipLevelList: [], // 正序的vip等级数组
      fakeVipLevelList: [], // 虚假的vip等级数组
      vipLevelList: [] // 用户数据处理和显示的vip等级数组
    };
  },
  created() {
    this.ascVipLevelList = ascVipLevelList;
  },
  methods: {
    setVipLevelList(realVipLevel) {
      const __vipLevel__ = sessionStorage.getItem('__vipLevel__');
      // 如果没有vip等级，那么就从1开始
      realVipLevel = realVipLevel || __vipLevel__ || '1';
      // e.g.当前是2级那么就取出2-15的vip等级
      const filteredVipLevelList = ascVipLevelList.filter(item => {
        return Number(item.value) >= Number(realVipLevel);
      });
      const fakeVipLevelList = filteredVipLevelList.map((item, idx) => {
        return {
          value: item.value,
          label: `VIP${idx + 1}`
        };
      });
      this.fakeVipLevelList = fakeVipLevelList;
      this.vipLevelList = fakeVipLevelList;
    },
    getFakeVipLevelText(realVipLevel) {
      return (this.fakeVipLevelList.find(item => item.value == realVipLevel) || {}).label;
    }
  }
};
